import "react-app-polyfill/ie9"
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"
// import "core-js/stable";
// // import "@babel/polyfill";

import React, { lazy, Suspense } from "react";
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import reducer from "./store/reducers/index";
import thunk from "redux-thunk";
// import { createBrowserHistory } from 'history';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/styles.scss'
import { ToastContainer } from "react-toastify";
// const App = lazy(() => import("./App"))
export const history = ""
// export const history = createBrowserHistory()

const store = createStore(reducer, compose(
    applyMiddleware(thunk)
));
// store.replaceReducer(reducer)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router history={history}>
        <Provider store={store} >
            <App />
            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </Provider>
    </Router>
);
